import React, { useState, useEffect, useMemo } from 'react'
import Select  from 'react-select'
import api     from '../../../services/api'
import Loader  from '../../Utils/Loader'
import '../../../css/accountOverlay.css'

const AccountOverlay = ({ account, roles, onClose }) => {
  const isNew = !account.id

  /* ---------------- form ---------------- */
  const [form, setForm]   = useState({ fullName:'', email:'', password:'', roles:[] })
  const [flash, setFlash] = useState({ type:'', msg:'' })
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    setForm({
      fullName : account.fullName || '',
      email    : account.email    || '',
      password : '',
      roles    : account.roles?.map(r => Number(r.id)) || [],
    })
  }, [account])

  /* ---------------- options ---------------- */
  const roleOptions = useMemo(
    () => roles.map(r => ({ value:r.id, label:r.name })),
    [roles]
  )

  /* ---------------- handlers ---------------- */
  const handleInput  = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }))
  const handleSelect = sel =>
    setForm(f => ({ ...f, roles: Array.isArray(sel) ? sel.map(o => Number(o.value)) : [] }))

  /* ---------------- submit ---------------- */
  const save = async e => {
    e.preventDefault()
    setFlash({})
    if (!form.email) return setFlash({ type:'error', msg:'Email richiesta' })
    if (isNew && !form.password)
      return setFlash({ type:'error', msg:'Password richiesta' })

    setSaving(true)
    try {
      const payload = { ...form, roles: form.roles.map(Number) }
      if (isNew) await api.post('/accounts', payload)
      else       await api.put(`/accounts/${account.id}`, payload)

      setFlash({ type:'success', msg:'Salvato!' })
      setTimeout(onClose, 800)
    } catch (err) {
      console.error('Errore salvataggio:', err)
      setFlash({ type:'error', msg:'Errore di rete' })
    } finally { setSaving(false) }
  }

  /* ---------------- render ---------------- */
  return (
    <div className="account-overlay-container" onClick={onClose}>
      <div className="account-overlay-content" onClick={e => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>×</button>
        <h2>{isNew ? 'Nuovo Account' : 'Modifica Account'}</h2>

        {flash.msg && <p className={flash.type}>{flash.msg}</p>}

        {saving ? (
          <Loader />
        ) : (
          <form onSubmit={save}>
            <label>
              Nome
              <input name="fullName" value={form.fullName} onChange={handleInput} />
            </label>

            <label>
              Email
              <input
                name="email"
                type="email"
                value={form.email}
                onChange={handleInput}
                required
              />
            </label>

            <label>
              {isNew ? 'Password' : 'Nuova password (facoltativa)'}
              <input
                name="password"
                type="password"
                value={form.password}
                onChange={handleInput}
                placeholder={isNew ? '' : 'Lascia vuoto per mantenere'}
              />
            </label>

            <label>
              Ruoli
              <Select
                isMulti
                options={roleOptions}
                value={roleOptions.filter(o => form.roles.includes(o.value))}
                onChange={handleSelect}
                classNamePrefix="select"
                placeholder="Seleziona ruoli..."
                menuPortalTarget={document.body}
                menuPosition="fixed"
                isClearable
              />
            </label>

            <button className="submit-btn" type="submit">
              {isNew ? 'Crea' : 'Salva'}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}

export default AccountOverlay
